let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8aF6Y")).then(() => parcelRequire('k2vLq'));